import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from 'react';
/** El mismo crecimiento y medición para los campos del blog y del CMS. */
export function AutoSizeTextarea({ value, style, rows = 1, ...props }) {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const area = ref.current;
        if (!area)
            return;
        const resize = () => {
            area.style.height = 'auto';
            const css = getComputedStyle(area);
            const padding = (parseFloat(css.paddingTop) || 0) + (parseFloat(css.paddingBottom) || 0);
            const border = (parseFloat(css.borderTopWidth) || 0) + (parseFloat(css.borderBottomWidth) || 0);
            area.style.height = `${area.scrollHeight + (css.boxSizing === 'border-box' ? border : -padding)}px`;
        };
        resize();
        if (typeof ResizeObserver === 'undefined')
            return;
        let width = area.getBoundingClientRect().width;
        const observer = new ResizeObserver(() => {
            const next = area.getBoundingClientRect().width;
            if (next !== width) {
                width = next;
                resize();
            }
        });
        observer.observe(area);
        return () => observer.disconnect();
    }, [value, props.className]);
    return _jsx("textarea", { ...props, ref: ref, rows: rows, value: value, style: { ...style, overflow: 'hidden', resize: 'none' } });
}
/** Nombre, icono y control alineados con las propiedades de una ficha del CMS. */
export function RecordProperty({ label, icon, leading, children, className = '', ...props }) {
    return (_jsxs("div", { ...props, className: `record-property ${className}`, children: [_jsx("span", { className: "record-property-leading", children: leading }), _jsxs("div", { className: "record-property-label", children: [icon ? _jsx("span", { className: "record-property-icon", "aria-hidden": "true", children: icon }) : null, label] }), _jsx("div", { className: "record-property-value", children: children })] }));
}
//# sourceMappingURL=RecordFields.js.map